export default class PlatformTemporaryDocument {
    workspaceID: string = "";
    documentID: string = "";
}
